import { useEffect, useState } from "react";
import { faqList } from "../../services/StaticService";

const Faq = () => {
  const [faqdata, setFaqdata] = useState([]);

  const getFAQList = async () => {
    const result = await faqList();
    if (result?.length > 0) {
      setFaqdata(result);
    }
  }

  useEffect(() => {
    getFAQList();
  }, []);

  return (
    <section className="FAQ_sec" id="FAQ_sec">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h6 className="title_txt yellow mb-4 pb-2">FAQ</h6>
          </div>
          <div className="col-md-12 mt-2">
            <div className="accordion" id="accordionExample">
              {faqdata?.length > 0 && faqdata?.map((faq, index) => {
                return (
                  <div className="accordion-item mb-4" key={index}>
                    <h2 className="accordion-header" id={`heading${faq.id}`}>
                      <button
                        className="accordion-button collapsed"
                        id={`faq-btn${faq.id}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${faq.id}`}
                        aria-expanded="true"
                        aria-controls={`collapse${faq.id}`}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse${faq.id}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${faq.id}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body pt-0">
                        <p className="gray">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
